import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';

interface SimulateMessageToApiProps {
  deviceid: DeviceId;
  data: string;
  tags: Array<string>;
}

interface SimulateMessageToApiReturn {
  success: boolean;
  error?: string;
}

const useSimulateMessageToApi = (deviceId?: DeviceId) => {
  const url = `${process.env.VITE_API_ROOT}/csr/rdm`;

  const callback = useCallback(
    async (data: string, topics?: Array<string>) => {
      if (!deviceId) {
        return undefined;
      }

      const result: SimulateMessageToApiReturn | undefined =
        await postFetcher<SimulateMessageToApiProps>({
          url,
          body: {
            deviceid: deviceId,
            data,
            tags: topics ?? [],
          },
        });

      return result;
    },
    [deviceId, url]
  );

  return callback;
};

export default useSimulateMessageToApi;
